export const SDK_VERSION = '7.19.0';
